import { useContext } from 'react';
import { ScryfallStatusContext } from '@/contexts/ScryfallStatusContext';

export const useScryfallStatusContext = () => {
  const context = useContext(ScryfallStatusContext);
  if (!context) {
    throw new Error('useScryfallStatusContext must be used within a ScryfallStatusProvider');
  }
  return context;
};